export enum TablesTab {
  Tables = 'tables',
  PaymentProcessing = 'paymentProcessing',
  PromoCodes = 'promoCodes',
  DigitalMenu = 'digitalMenu',
  OrderSettings = 'orderSettings',
  ServerFlow = 'serverFlow',
}
